import styles from './index.module.scss';
import Typography from '@primitives/Typography/Typography';
import AlertIcon from '@icons/AlertIcon/AlertIcon';

function Header() {
  return (
    <div className={styles.header}>
      <Typography
        className={styles.textContainer}
        as="div"
        variant="p2"
        color="var(--navi-color-gray-c1)"
      >
        <AlertIcon color="var(--navi-color-red-base)" size="md" />
        <span>
          To access your account, <b>please login to COSMOS</b>
        </span>
      </Typography>
    </div>
  );
}

export default Header;
